import React from 'react'

const TripManifest = ({ shipment, render }) => {
    let showHide = 'hide'
    if (render === true) {
        showHide = 'show'
    }

    if (shipment && showHide === 'show') {
        return (
            <div>
                <a
                    href={
                        "https://www2.shippersedge.com/includes/cfm/static_other.cfm?d=trip_manifest&i=" +
                        shipment.id +
                        "&print&wsdl"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open Trip Manifest In New Tab"
                >
                    Trip Manifest
                </a>
            </div>
        )
    } else { return null }
}

export default TripManifest
